import _ from "lodash";
import React, { useState, useMemo } from "react";
import classes from "./ReportItem.scss";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import I18nHOC from "UIComponents/I18nHOC";
import UIButton from "UIComponents/UIButton";
import LinkWithTooltip from "UIComponents/LinkWithTooltip";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import TheatreModeV2 from "UIComponents/TheatreModeV2";
import moment from "moment";
import { goToRelativeRoute } from "modules/Services";
import { getPrintFile } from "modules/PrintThunks";
import { ProgressReportCardImage } from "ProgressReportCommon/components";
import { DownloadCloudOutlined } from "@toddle-edu/ds-icons";
import { IconButton } from "@toddle-edu/ds-web";
import { isWebview as getIsWebView } from "Utils/SentralHelpers";

const styles = {
  buttonStyle: {
    height: "48px",
    width: "160px",
  },
};

const ReportItem = props => {
  const {
    t,
    filteredNodes,
    publishedAt,
    publishedProgressReportId,
    studentProgressReportId,
    getPrintFile,
    index,
    curriculumProgramType,
    reportTitle,
  } = props;
  const [reportPreviewData, setReportPreviewData] = useState(null);

  // When coverSheet is disabled prTitle does not comes in filtered nodes
  // So we use report title as fallback
  const title = _.get(filteredNodes, "prTitle.value", "") || reportTitle;
  const isReportPreviewLoading = _.get(reportPreviewData, "isLoading", false);
  const reportPreviewUrl = _.get(reportPreviewData, "url", null);

  const mediaAttachments = useMemo(
    () => ({
      attachments: [
        {
          type: "FILE",
          mimeType: "application/pdf",
          url: reportPreviewUrl,
          name: title,
        },
      ],
    }),
    [reportPreviewUrl, title]
  );

  const handleViewClick = async () => {
    if (!getIsWebView()) {
      const { goToRelativeRoute } = props;
      goToRelativeRoute({
        route: studentProgressReportId,
      });
      return;
    }
    setReportPreviewData({ isLoading: true });
    const result = await getPrintFile({
      id: studentProgressReportId,
      type: "progressreport",
      isDownload: false,
      shouldOpenInWindow: false,
      name: title,
      metadata: {
        studentProgressReportId: studentProgressReportId,
        curriculumProgramType: curriculumProgramType,
      },
    });
    setReportPreviewData({ isLoading: false, url: result });
  };

  const onCloseClick = () => {
    setReportPreviewData(null);
  };

  const handleDownloadClick = () => {
    getPrintFile({
      id: studentProgressReportId,
      type: "progressreport",
      isDownload: true,
      name: title,
      metadata: {
        studentProgressReportId: studentProgressReportId,
        curriculumProgramType: curriculumProgramType,
      },
    });
  };

  return (
    <>
      <div className={classes.itemContainer}>
        <ProgressReportCardImage index={index} />
        <div className={classes.rightContainer}>
          <div className={classes.detailsContainer}>
            <div>
              <div className={classes.setName}>{title}</div>
              <div className={classes.label}>
                {t("progressReport:generated_on")}:&nbsp;
                {moment(publishedAt).format("DD MMM, YYYY")}
              </div>
            </div>
          </div>
          <div className={classes.buttonContainer}>
            <div className={classes.downloadIcon}>
              <LinkWithTooltip
                tooltip={t("common:download")}
                placement={"bottom"}
                href={null}
              >
                <IconButton
                  icon={
                    <DownloadCloudOutlined size="x-small" variant="subtle" />
                  }
                  onClick={handleDownloadClick}
                  dsVersion="2.0"
                  variant={"neutral"}
                  type={"plain"}
                  size={"medium"}
                  aria-label={t("common:download")}
                />
              </LinkWithTooltip>
            </div>
            <div className={classes.viewReport}>
              <UIButton
                size={"sm"}
                color={"blue"}
                type={"filled"}
                onClick={handleViewClick}
                containerStyle={styles.buttonStyle}
              >
                {t("progressReport:view_report")}
              </UIButton>
            </div>
          </div>
        </div>
      </div>
      {isReportPreviewLoading ? <FullScreenLoader /> : null}
      {reportPreviewUrl ? (
        <TheatreModeV2
          mediaAttachments={mediaAttachments}
          activeAttachmentIndex={0}
          toggleTheatreMode={onCloseClick}
        />
      ) : null}
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    childID: _.get(state, "login.userInfo.childID", ""),
  };
};

const mapActionCreators = {
  goToRelativeRoute,
  getPrintFile,
};

export default compose(
  I18nHOC({ resource: ["common", "progressReport"] }),
  connect(mapStateToProps, mapActionCreators)
)(ReportItem);
